import type { MenuSnapshotProduct } from '../types/menu-snapshot';

export function getProductDisplayName(product: MenuSnapshotProduct, languageCode = 'es'): string {
  return (
    product.product_translations?.find(t => t.language_code === languageCode)?.name ??
    product.product_translations?.[0]?.name ??
    ''
  );
}

export function getProductDescription(product: MenuSnapshotProduct, languageCode = 'es'): string {
  return product.product_translations?.find(t => t.language_code === languageCode)?.description ?? '';
}
